module.exports = __webpack_public_path__ + "img/saum_reinweiss_ral9010.561bb4b1.jpg";